export const BlogData = [{
        id: 1,
        image: "assets/images/blog/blog-4.webp",
        title: "React'e Yeni Başlayanlar İçin Temel Kavramlar",
        content: "React, dinamik ve yüksek performanslı kullanıcı arayüzleri geliştirmek için kullanılan bileşen tabanlı bir JavaScript kütüphanesidir. Daha fazla bilgi almak için lütfen tıklayın.",
        label: " #ReactJS #Developer #Design",
        history: "03 Ocak 2025"
    },
    {
        id: 2,
        image: "assets/images/blog/blog-4.webp",
        title: "React’te Bileşenler ve Props: Temel Bilgiler",
        content: "React'te bileşenler, kullanıcı arayüzlerini modüler hale getirirken, props veri iletimini sağlar. Bu sayede, dinamik ve tekrar kullanılabilir arayüzler oluşturmak mümkün olur. Daha fazla bilgi için lütfen tıklayın.",
        label: "#Props #Components",
        history: "16 Şubat 2025"
    },
    {
        id: 3,
        image: "assets/images/blog/blog-4.webp",
        title: "React'te Etkinlikler ve Olay Yönetimi: Etkileşim",
        content: "React'te olaylar, dinleyiciler, event handler fonksiyonları ve form yönetimi, kullanıcı etkileşimlerini dinamik ve etkili şekilde yönetmeyi sağlar. Daha fazla bilgi için lütfen tıklayın.",
        label: "#ReactJS #EventListeners",
        history: "25 Mart 2025"
    },
]